export const LISTINGS_DESC = 'Listings (Newest)';
export const LISTINGS_ASC = 'Listings (Oldest)';
export const PRICE_DESC = 'Price (Highest)';
export const PRICE_ASC = 'Price (Lowest)';
